import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import EnrollmentFilterViewer from 'automation-ui-enrollment/components/filters/EnrollmentFilterViewer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function ListBranchActionExplainer({
  action,
  flowObjectTypeId
}) {
  const connection = action.getConnection();
  const listBranches = connection.getBranches();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [listBranches.map((listBranch, index) => {
      const branchName = /*#__PURE__*/_jsx("strong", {
        children: listBranch.getBranchName() || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-action-features.action-features.list-branch.branch-name.default",
          options: {
            branchNumber: index + 1
          }
        })
      });
      const isFirstBranch = index === 0;
      const messageKey = isFirstBranch ? 'automation-ui-action-features.action-features.list-branch.explainer.firstBranch' : 'automation-ui-action-features.action-features.list-branch.explainer.followingBranch';
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
          className: `display-block m-bottom-1 m-top-${isFirstBranch ? 0 : 2}`,
          message: messageKey,
          options: {
            branchName
          }
        }), /*#__PURE__*/_jsx(EnrollmentFilterViewer, {
          value: listBranch.getFilterBranch(),
          objectTypeId: flowObjectTypeId,
          emptyFilterMessage: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-action-features.action-features.list-branch.missingFilters"
          })
        })]
      }, index);
    }).toArray(), /*#__PURE__*/_jsx(FormattedReactMessage, {
      className: "display-block m-top-2",
      message: "automation-ui-action-features.action-features.list-branch.explainer.defaultBranch",
      options: {
        branchName: /*#__PURE__*/_jsx("strong", {
          children: connection.getDefaultBranchName() || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-action-features.action-features.list-branch.branch-name.otherwiseConditionDefault"
          })
        })
      }
    })]
  });
}